const SUPPORTED_LOCALES = ["en-us", "zh-cn", "zh-hk", "zh-mo", "zh-tw", "ja-jp"];
const DEFAULT_LOCALE = "en-us";

function normalizeLocale(inputLocale) {
  if (!inputLocale) {
    return DEFAULT_LOCALE;
  }

  const normalized = String(inputLocale).toLowerCase().replace("_", "-");
  if (SUPPORTED_LOCALES.includes(normalized)) {
    return normalized;
  }

  const matchedLocale = SUPPORTED_LOCALES.find(
    (locale) => locale.split("-")[0] === normalized.split("-")[0]
  );

  return matchedLocale || DEFAULT_LOCALE;
}

export { SUPPORTED_LOCALES, DEFAULT_LOCALE, normalizeLocale };
